export default __webpack_public_path__ + "static/media/Archdeacon's Harness of the Earthen Prison.6231f437.jpg";